/**
 * nonStepDomain — domains that are events but NOT steps.
 *
 * Not every `io.doclm.*` event describes work the user can inspect. The rule is:
 * **an event is a step iff it represents work worth inspecting.** Everything else
 * routes to turn metadata, chat metadata, or a system-notice lane — and must not
 * appear in the agent trace.
 */

import type { DomainInterpreter } from 'src/content/ChatV2/steps/model/types';
import { EVENT_DOMAIN } from 'src/content/ChatV2/steps/wire/eventType';

/**
 * An interpreter that acknowledges a domain and produces nothing.
 */
export function createNonStepDomain(domain: string): DomainInterpreter {
  return {
    domain,
    shouldCreate: () => false
  };
}

/**
 * `run.*` — turn lifecycle. Owned by
 * [chatStreamMachine](../../machines/chatStreamMachine.ts); `run.completed` also
 * carries the settle payload, which `StreamSettler` reads. Never a step.
 */
export const runDomain = createNonStepDomain(EVENT_DOMAIN.RUN);

/**
 * `usage.updated` — token counts. Never emitted as an event in practice (usage arrives
 * inside `additional_steps[].usage_metadata`), and it has no lifecycle at all, so it
 * could never be a step even in principle.
 */
export const usageDomain = createNonStepDomain(EVENT_DOMAIN.USAGE);
